import React, { useState } from 'react';
import { Landing } from '../Landing';
import TermsConditions from '../TermsConditions';
import ConnectButton from '../ConnectButton';

type TermsAndConnectProps = {
  textColor: string;
  buttonTextColor: string;
  linkTextColor: string;
  checkboxBackground: string;
  buttonColor: string;
  checkedColor: string;
  useEthereum: boolean;
  connectMetamask: () => void;
  useSolana: boolean;
  connectPhantom: () => void;
  hasEthWallet: boolean;
  hasSolanaWallet: boolean;
  setSkipOtherWallet: () => void;
}
const TermsAndConnect = (props: TermsAndConnectProps) => {
  const [termsAccepted, setTermsAccepted] = useState(false);

  const toggleTerms = () => {
    // console.log('connect toggling terms',termsAccepted);
    setTermsAccepted(!termsAccepted);
  }

  return (
    <div style={{
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      fontFamily: 'Lato,"Helvetica Neue",Arial,Helvetica,sans-serif',
    }}>
      <ConnectButton 
        termsAccepted={termsAccepted} 
        useEthereum={props.useEthereum}
        connectMetamask={props.connectMetamask}
        useSolana={props.useSolana}
        connectPhantom={props.connectPhantom}
        backgroundColor={props.buttonColor}
        setSkipOtherWallet={props.setSkipOtherWallet}
        hasEthWallet={props.hasEthWallet}
        hasSolanaWallet={props.hasSolanaWallet}
        color={props.buttonTextColor} />
      <TermsConditions 
        textColor={props.textColor} 
        termsAccepted={termsAccepted}
        checkboxBackground={props.checkboxBackground}
        checkedColor={props.checkedColor}
        linkColor={props.linkTextColor}
        changeHandler={toggleTerms}
      />
    </div>
  )
}

const ScanningWallet = (props: {textColor: string}) => {
  return (
    <div style={{
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center',
      fontFamily: '"Cairo",sans-serif',
    }}>
      <h2 style={{color: props.textColor}}>Connecting wallet...</h2>
    </div>
  )
}

export type ConnectProps = {
  backgroundImage: string;
  clientLogo: string;
  leapnLogo: string;
  worldName: string;
  logoAlt: string;
  buttonColor?: string;
  checkedColor?: string;
  checkboxBackground?: string;
  textColor?: string;
  buttonTextColor?: string;
  linkTextColor?: string;
  hideWorldLogo?: boolean;
  hideLeapnLogo?: boolean;
  scanningWallet?: boolean;
  isConnecting: boolean;
  useEthereum: boolean;
  connectMetamask: () => void;
  useSolana: boolean;
  connectPhantom: () => void;
  hasEthWallet: boolean;
  hasSolanaWallet: boolean;
  setSkipOtherWallet: () => void;
}
export const Connect = (props: ConnectProps) => {
  const { backgroundImage, clientLogo, leapnLogo, worldName, logoAlt } = props;
  const hideWorldLogo = !!props.hideWorldLogo;
  const hideLeapnLogo = !!props.hideLeapnLogo;
  const landingProps = { backgroundImage, clientLogo, leapnLogo, worldName, logoAlt, hideWorldLogo, hideLeapnLogo };
  const textColor = props.textColor ?? 'white';
  const linkTextColor = props.linkTextColor ?? 'blue';
  const buttonTextColor = props.buttonTextColor ?? 'white';
  const checkboxBackground = props.checkboxBackground ?? 'rgba(0,0,0,0.2)'
  const buttonColor = props.buttonColor ?? 'blue';
  const checkedColor = props.checkedColor ?? buttonColor;  //default to match the button

  return (
    <Landing {...landingProps}>
      { (props.scanningWallet || props.isConnecting) ? 
        <ScanningWallet textColor={textColor}/> : 
        <TermsAndConnect 
          useEthereum={props.useEthereum}
          connectMetamask={props.connectMetamask} 
          useSolana={props.useSolana}
          connectPhantom={props.connectPhantom}
          checkboxBackground={checkboxBackground}
          buttonColor={buttonColor}
          checkedColor={checkedColor}
          buttonTextColor={buttonTextColor}
          linkTextColor={linkTextColor}
          hasEthWallet={props.hasEthWallet}
          hasSolanaWallet={props.hasSolanaWallet}
          setSkipOtherWallet={props.setSkipOtherWallet}
          textColor={textColor} />
      }
    </Landing>
  )
}

export default Connect;